import gql from "graphql-tag";

export const WORKOUT_QUERY = gql`
  query Workout($id: ID!) {
    workout(id: $id) {
      id
      name
      label
      duration
      difficulty
      equipment
      followsSequence
      instructions
      day
      embedUrl
      workoutActivities {
        id
        repetition
        sets
        note
        hasRecovery
        recovery
        isNote
        noteTitle
        noteDescription
        activity {
          name
          description
          imageLink
        }
        workoutActivityIntervals {
          id
          detail
        }
      }
      useractivitySet {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

export const WORKOUT_BLOCKS_QUERY = gql`
  query workoutBlocks($orderBy: String) {
    workoutBlocks(orderBy: $orderBy) {
      edges {
        node {
          id
          title
          visible
        }
      }
    }
  }
`;

export const WORKOUT_SUBSCRIPTION_BLOCKS_QUERY = gql`
  query workoutSubscriptionBlocks($after: String, $orderBy: String, $block_Title: String, $addedToGroup: String) {
    workoutSubscriptionBlocks(
      after: $after
      orderBy: $orderBy
      block_Title: $block_Title
      addedToGroup: $addedToGroup
    ) {
      edges {
        node {
          id
          createdAt
          startDate
          endDate
          addedToGroup
          block {
            title
          }
          user {
            id
            firstName
            lastName
            userProfile {
              phone
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ADD_TO_GROUP_MUTATION = gql`
  mutation updateAddToGroup($subscriptionBlockId: ID!, $addedToGroup: String!) {
    updateAddToGroup(subscriptionBlockId: $subscriptionBlockId, addedToGroup: $addedToGroup) {
      success
      error
    }
  }
`;
